import React, { FunctionComponent, memo } from 'react';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import { Heading, Flex, Box } from 'mdlkit';
import { Breadcrumb, PersonIcon, CoverageIcon } from './RegisterBreadcrumb';

const CREATE_ACCOUNT_ROUTE = 'register';
const CHECK_COVERAGE_ROUTES = [
  'insurance',
  'eligibility-error',
  'register-review',
];

const findCoverageRoute = (pathname) =>
  CHECK_COVERAGE_ROUTES.find((route) => route === pathname) ||
  CHECK_COVERAGE_ROUTES[0];

const isStepComplete = (step, pathname) => {
  const ORDERED_ROUTES = [CREATE_ACCOUNT_ROUTE, ...CHECK_COVERAGE_ROUTES];
  const stepIndex = ORDERED_ROUTES.findIndex((route) => step === route);
  const currentStepIndex = ORDERED_ROUTES.findIndex(
    (route) => pathname === route
  );

  return stepIndex < currentStepIndex;
};

interface Props {
  heading?: string;
  hideBreadcrumb?: boolean;
}

const V2RegisterBreadcrumb: FunctionComponent<Props> = ({
  heading,
  hideBreadcrumb,
}: Props) => {
  const router = useRouter();
  const { formatMessage: f } = useIntl();
  const currentPath = router.pathname.split('/').pop() || '';

  return (
    <Box width={1}>
      <Heading as="h1" align="center">
        {typeof heading === 'undefined'
          ? f({ id: 'register.welcomeHeading' })
          : heading}
      </Heading>

      {!hideBreadcrumb ? (
        <Flex as="ul" pt="sm">
          <Breadcrumb
            id="createAccountCrumb"
            text={f({ id: 'register.createAccount' })}
            active={CREATE_ACCOUNT_ROUTE === currentPath}
            completed={isStepComplete(CREATE_ACCOUNT_ROUTE, currentPath)}
            icon={<PersonIcon />}
          />

          <Breadcrumb
            id="checkCoverageCrumb"
            text={f({ id: 'register.checkCoverage' })}
            active={CHECK_COVERAGE_ROUTES.includes(currentPath)}
            completed={isStepComplete(
              findCoverageRoute(currentPath),
              currentPath
            )}
            icon={<CoverageIcon />}
          />
        </Flex>
      ) : null}
    </Box>
  );
};

export default memo(V2RegisterBreadcrumb);
